import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import TabMenu from './TabMenu';

const ImportTest = () => {
  const navigate = useNavigate();
  const { organization } = useContext(OrganizationContext);

  const [error, setError] = useState('');

  //   const handleFileChange = (event) => {
  //     const selectedFile = event.target.files[0];

  //     // Reset errors and file state
  //     setError('');
  //     setFile(null);

  //     if (!selectedFile) {
  //         setError('Please select a file.');
  //         return;
  //     }

  //     // Check file type (for CSV)
  //     if (selectedFile.type !== 'text/csv' && selectedFile.type !== 'application/vnd.ms-excel') {
  //         setError('Invalid file type. Only CSV files are allowed.');
  //         return;
  //     }

  //     // Check file size (e.g., max 5 MB)
  //     const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
  //     if (selectedFile.size > maxSizeInBytes) {
  //         setError('File size exceeds the 5 MB limit.');
  //         return;
  //     }

  //     // If all checks pass, set the file state
  //     setFile(selectedFile);
  //     console.log('File selected:', selectedFile);
  //   };


  // const convertImageToBase64 = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = error => reject(error);
  //   });
  // };

  const [file, setFile] = useState(null);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.files[0]);
  };
  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      // Resolve the base64 string when the file is successfully read
      reader.onload = () => resolve(reader.result);
      
      // Reject in case of any errors
      reader.onerror = error => reject(error);
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization
    const base64String = file?await convertImageToBase64(file):"";
    fetch(authService.getApiUrl() + 'labtests-import', {
    method: 'POST', // Change method to PUT
    body: JSON.stringify({ 
                           image:base64String,
                           organization_id: organization,
     }), // Include the data to be updated in the body
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
    },
    })
    .then((res) => res.json())
    .then((result) => {
      alert(result.data);
      //console.log(result.data)
        //setFormData(result.data); // Set the form data with the result
       // navigate(`/admin/lab-management/category`);
    })
    .catch((err) => {
        console.log(err.message); // Handle any errors
    });

};

return (
    <>
      <div className='main-container'>
        <div className='container-fluid'>
          <Breadcrumb/>
          <TabMenu name="labtest"/>
          <div className='category-table'>
            <div className='flex-cont add-cat'>
              <div className='heading'>
                <h3>Import Tests</h3>
              </div>
            </div>
            <div className="card">
              <div className="card-body custom-edit-service">
                <form className="needs-validation clearfix" onSubmit={handleSubmit} key="addform">
                  <div className="addtest-fields mb-3">
                    <div className="flex-cont">

                      <div className="full-cont">
                        <div className='upload-img-cont'>
                          <label>
                            Upload CSV File <span className="text-danger">*</span>
                          </label>
                          <input
                            type="file"
                            id="file"
                            accept=".csv"
                            name="file"
                            onChange={handleImageChange}
                            className="form-control"
                            
                          />
                          {error && <p style={{ color: 'red' }}>{error}</p>}
                          <small className="text-secondary" style={{float:'right'}}>
                            Download sample file format <b><a href={authService.getApiDomainUrl()+'uploads/labtests/labtests.csv'}>Download</a></b>
                          </small>
                        </div>
                      </div>
                    </div>

                    
                      <div className="submit-section">
                        <button
                          className="btn btn-primary submit-btn"
                          type="submit"
                          name="form_submit"
                        >
                          Submit
                        </button>
                      </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportTest;
